import Button from '@material-ui/core/Button';
import styles from './Terrain3DButton.module.css';
import terrainIcon from '../../../assets/images/terrain-icon.svg';

export const Terrain3DButton = ({
    onToggleTerrain,
    isTerrain3DEnabled,
}) => {
    return (
        <div className={styles.buttonWrapper}>
            <Button
                onClick={onToggleTerrain}
                color={isTerrain3DEnabled ? 'primary' : 'default'}
                variant='contained'
                size='small'
                title="Toggle 3D Terrain"
                className={isTerrain3DEnabled ? styles.active : ''}
            >
                <img
                    src={terrainIcon}
                    alt="3D Terrain"
                    className={styles.terrainIcon}
                />
            </Button>
        </div>
    );
};
